export default __webpack_public_path__ + "static/media/Manslayer.a2e268f0.jpg";